import PropTypes from "prop-types";
import React from "react";
import { defineMessages, FormattedMessage } from "react-intl";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import * as styles from "./CreateSubscription.module.scss";

const messages = defineMessages( {
	includes: {
		id: "provisioning.create.includes",
		defaultMessage: "Includes",
	},
} );

/**
 * The products and services a provisionable product includes.
 *
 * @param {Object} props Component props.
 *
 * @returns {JSX.Element|null} The list, or null when there is nothing to list.
 */
function IncludedProductGroups( { productGroups } ) {
	if ( productGroups.length === 0 ) {
		return null;
	}

	return (
		<div>
			<div className={ styles.includesLabel }>
				<FormattedMessage { ...messages.includes } />
			</div>
			<div className={ styles.checkmarkList }>
				{ productGroups.map( ( name, key ) => (
					<div key={ `pg-${ key }` }>
						<CheckCircleIcon aria-hidden="true" />
						{ name }
					</div>
				) ) }
			</div>
		</div>
	);
}

IncludedProductGroups.propTypes = {
	productGroups: PropTypes.arrayOf( PropTypes.string ).isRequired,
};

export default IncludedProductGroups;
